export const SCHEDULE_API = {
  UPDATE_WORKING_DAYS: 'classes/{classId}/workingDays',
  GET_SCHEDULE_BY_CLASS_ID: 'classes/{classId}/schedule',
  GET_SCHEDULE_BY_CONTENT_ID: 'classes/{classId}/scheduleEntry/{contentId}',
  GET_SCHEDULE_TYPE: 'classes/{classId}/scheduleType',
  ADD_SCHEDULE_BLOCK: 'classes/{classId}/scheduleBlock',
  UPDATE_SCHEDULE_BLOCK: 'classes/{classId}/scheduleBlock/{scheduleBlockId}',
  DELETE_SCHEDULE_BLOCK: 'classes/{classId}/scheduleBlock/{scheduleBlockId}',
  SCHEDULE_HOURS: 'classes/{classId}/scheduleHours',
  SCHEDULE_TYPE: 'classes/{classId}/scheduleType',
}

export const SCHEDULE_API_PARAMS = {
  CLASS_ID: '{classId}',
  SCHEDULE_BLOCK_ID: '{scheduleBlockId}',
  CONTENT_ID: '{contentId}',
}

export enum WORKING_DAYS {
  SUNDAY,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY,
}